// src/components/KatarutaSuggest.tsx
//
// カタルタ式モードのコントロールバー。
// ・カタルタ式 ●/○ : 機能全体のON/OFF
// ・チップ / ダイレクト : 候補表示方式の切り替え
// ・毎回 / 自然 : 頻度制御
// ・カードタイプ選択 : D30/有料のみ表示

"use client";

import React from "react";
import type { CardTypeKey, FreqMode, SuggestMode } from "@/hooks/useKatarutaSuggest";

const CARD_TYPES: { key: CardTypeKey; label: string }[] = [
  { key: "standard", label: "スタンダード" },
  { key: "storytelling", label: "ストーリーテリング" },
  { key: "logical", label: "ロジカル" },
  { key: "life", label: "ライフ" },
  { key: "emotion", label: "エモーション" },
];

interface Props {
  enabled: boolean;
  setEnabled: (v: boolean) => void;
  suggestMode: SuggestMode;
  setSuggestMode: (m: SuggestMode) => void;
  cardType: CardTypeKey;
  setCardType: (t: CardTypeKey) => void;
  freqMode: FreqMode;
  setFreqMode: (m: FreqMode) => void;
  isPaidOrTrial: boolean;
}

export default function KatarutaSuggest({
  enabled,
  setEnabled,
  suggestMode,
  setSuggestMode,
  cardType,
  setCardType,
  freqMode,
  setFreqMode,
  isPaidOrTrial,
}: Props) {
  return (
    <div className="flex items-center gap-3 mt-1 flex-wrap">
      {/* カタルタモード ON/OFF */}
      <button
        type="button"
        onClick={() => setEnabled(!enabled)}
        className={`text-xs transition-colors ${
          enabled ? "text-violet-500 hover:text-violet-700" : "text-gray-400 hover:text-gray-600"
        }`}
      >
        カタルタモード {enabled ? "●" : "○"}
      </button>

      {enabled && (
        <>
          {/* チップ / ダイレクト */}
          <div className="flex items-center gap-1 text-xs">
            <button
              type="button"
              onClick={() => setSuggestMode("chip")}
              className={`transition-colors ${
                suggestMode === "chip" ? "text-gray-700 font-medium" : "text-gray-400 hover:text-gray-600"
              }`}
            >
              チップ
            </button>
            <span className="text-gray-200">/</span>
            <button
              type="button"
              onClick={() => setSuggestMode("direct")}
              className={`transition-colors ${
                suggestMode === "direct" ? "text-gray-700 font-medium" : "text-gray-400 hover:text-gray-600"
              }`}
            >
              ダイレクト
            </button>
          </div>

          {/* 頻度トグル */}
          <div className="flex items-center gap-1 text-xs">
            <button
              type="button"
              onClick={() => setFreqMode("always")}
              className={`transition-colors ${
                freqMode === "always" ? "text-gray-700 font-medium" : "text-gray-400 hover:text-gray-600"
              }`}
            >
              毎回
            </button>
            <span className="text-gray-200">/</span>
            <button
              type="button"
              onClick={() => setFreqMode("sparse")}
              className={`transition-colors ${
                freqMode === "sparse" ? "text-gray-700 font-medium" : "text-gray-400 hover:text-gray-600"
              }`}
            >
              自然
            </button>
          </div>

          {/* カードタイプ（D30/有料のみ） */}
          {isPaidOrTrial && (
            <select
              value={cardType}
              onChange={(e) => setCardType(e.target.value as CardTypeKey)}
              className="text-xs border border-gray-200 rounded px-2 py-0.5 text-gray-400 bg-transparent"
            >
              {CARD_TYPES.map((t) => (
                <option key={t.key} value={t.key}>
                  {t.label}
                </option>
              ))}
            </select>
          )}
        </>
      )}
    </div>
  );
}
